var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmoothnessEventsPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Smoothness Events",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smoothness Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0123,10.5c0,5.8-9.997,14.5-9.997,14.5C10.0153,25,.01825,16.3,.01825,10.5-.11646,4.84036,4.35748,.1413,10.0153,0c5.6578,.1413,10.1318,4.84036,9.997,10.5Z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4573,15H6.81262c-.1502,0-.27198-.1199-.27198-.2677,0-.1479,.12179-.2677,.27198-.2677h7.64358c.2761,0,.4998-.2204,.4998-.4921v-.0932c0-.2718-.2237-.4923-.4998-.4926H5.54411c-.57665,0-1.04411-.4601-1.04411-1.0278,0-.5676,.46746-1.0277,1.04411-1.0277h1.23803c.1502,0,.27197,.1198,.27197,.2677s-.12178,.2677-.27197,.2677h-1.23803c-.27623,0-.50016,.2205-.50016,.4923,0,.2719,.22394,.4924,.50016,.4924H14.4562c.5762,.0006,1.0432,.4603,1.0438,1.0275v.0937c.0006,.5668-.4658,1.0269-1.0417,1.0275h-.001ZM9.99952,4c-1.65669,.00028-2.99952,1.33449-2.99952,2.98024,0,1.60679,2.72045,3.86606,2.83608,3.96106,.09511,.0783,.23272,.0783,.32792,0,.1161-.095,2.836-2.35479,2.836-3.96106-.002-1.6453-1.3443-2.97852-3.00048-2.98024Zm0,4.07033c-.6052,.00028-1.09601-.48685-1.09633-1.08803-.00025-.60118,.49006-1.08878,1.09526-1.08908,.60515-.00027,1.09605,.48685,1.09635,1.08803v.00103c0,.6009-.4904,1.08805-1.09528,1.08805Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothnessEventsPoint);
export default __webpack_public_path__ + "static/media/smoothness-events-point.dd2b6731fe1a8d4abdc5e7e15932f222.svg";
export { ForwardRef as ReactComponent };